import api from 'api'
import { queryParamSerializer } from 'lib/api/queryParamSerializer'
import type { IndeedFlexShiftIssue } from 'pages/IndeedFlex/shared/constants/shiftIssues'

export type IndeedFlexShiftIssuesItem = {
  ifClientId: number
  clientName: string
  ifShiftId: number
  ifJobId: number
  ifRoleId: number
  ifVenueId: number
  roleName: string
  venueName: string
  timezone: string
  startTime: string
  endTime: string
  allocationWithoutBuffer: number
  companyId: number | null
  companyName: string | null
  workShiftId: number | null
  issues: IndeedFlexShiftIssue[]
}

export type IndeedFlexShiftIssuesItems = IndeedFlexShiftIssuesItem[]

type ListIndeedFlexShiftIssuesRequest = {
  page: number
  pageSize: number
  daysAgo?: number | null
  ifClientIds?: number[] | null
  companyIds?: number[] | null
  issues?: IndeedFlexShiftIssue[] | null
}

export type ListIndeedFlexShiftIssuesResponse = {
  items: IndeedFlexShiftIssuesItems
  totalRows: number
  totalPages: number
  currentPage: number
  pageSize: number
}

export const listIndeedFlexShiftIssues = async (
  request: ListIndeedFlexShiftIssuesRequest
): Promise<ListIndeedFlexShiftIssuesResponse> => {
  const params = {
    page: request.page,
    page_size: request.pageSize,
    days_ago: request.daysAgo,
    if_client_ids: request.ifClientIds,
    company_ids: request.companyIds,
    issues: request.issues,
  }

  const response = await api.get<ListIndeedFlexShiftIssuesResponse>(
    '/admin/indeed_flex/shifts_issues',
    { params, paramsSerializer: queryParamSerializer }
  )
  return response.data
}
